import React, { createContext, useContext, useState, useEffect } from 'react';
import { GetCustomer } from "../apis/Api.js";
import toast from 'react-hot-toast';
import { Loader } from "../common/Loader.jsx";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState(null);
  const [user, setUser] = useState(null);
  const [auth, setAuth] = useState(false);

  useEffect(() => {
    const handleTokenUpdate = () => {
      checkAuth();
    };
  
    checkAuth();
    window.addEventListener('storage', handleTokenUpdate);
    window.addEventListener('tokenUpdate', handleTokenUpdate);
  
    return () => {
      window.removeEventListener('storage', handleTokenUpdate);
      window.removeEventListener('tokenUpdate', handleTokenUpdate);
    };
  }, []);
  const checkAuth = async () => {
    try {
      setLoading(true);
      const storedToken = localStorage.getItem('token');

      if (!storedToken) {
        silentLogout();   
        return;
      }

      setToken(storedToken);
      const userFetched = await getUser(storedToken);

      if (userFetched) {
        setAuth(true);
      } else {
        silentLogout(); 
      }

    } catch (error) {
      console.log('Failed to check auth', error);
      silentLogout();
    } finally {
      setLoading(false);
    }
  };

  const getUser = async (userToken) => {
    try {
      setLoading(true);
      const response = await GetCustomer({ cust_token: userToken });
  
      if (response.status === 200) {
        setUser(Array.isArray(response.data) ? response.data : [response.data]); 
        return true;
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
    return false;
  };

  const logout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setUser(null);
    setAuth(false);
    toast.success('Logged out successfully'); 
  };

  const silentLogout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setUser(null);
    setAuth(false);
  };

  const value = {
    token,
    user,
    auth,
    setUser,
    logout
  };

  if (loading) {
    return (
      <div className="container my-5">
        <div className="row">
          <div className="col-md-12 d-flex align-items-center justify-content-center" style={{ minHeight: "100vh", backgroundColor: 'white' }}>
            <Loader />
          </div>
        </div>
      </div>
    );
  }

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
